import React, { useState, useEffect, useCallback } from "react";
import { getErrors } from "../api/client";
import ErrorList from "../components/ErrorList";
import { Search, Sparkles } from "lucide-react";

function Errors() {
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [severity, setSeverity] = useState("");

  const fetchErrors = useCallback(async () => {
    try {
      setLoading(true);
      const params = { limit: 50 };
      if (search) params.search = search;
      if (severity) params.severity = severity;

      const data = await getErrors(params);
      setErrors(data.errors || []);
    } catch (error) {
      console.error("Error fetching errors:", error);
    } finally {
      setLoading(false);
    }
  }, [search, severity]);

  useEffect(() => {
    fetchErrors();
  }, [fetchErrors]);

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-2xl font-bold bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent flex items-center gap-2">
          Errors
          <Sparkles className="w-4 h-4 text-cyan-400" />
        </h2>
        <p className="text-gray-400">All captured errors with AI analysis</p>
      </div>

      <div className="flex flex-wrap gap-3 mb-6">
        <div className="flex-1 min-w-[200px] relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" />
          <input
            type="text"
            placeholder="Search errors..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full pl-10 pr-4 py-2 bg-gray-900/50 border border-gray-800/50 rounded-xl text-white placeholder-gray-500 focus:outline-none focus:border-cyan-500 focus:ring-2 focus:ring-cyan-500/20 transition-all duration-200"
          />
        </div>

        <select
          value={severity}
          onChange={(e) => setSeverity(e.target.value)}
          className="px-4 py-2 bg-gray-900/50 border border-gray-800/50 rounded-xl text-white focus:outline-none focus:border-cyan-500 focus:ring-2 focus:ring-cyan-500/20 transition-all duration-200"
        >
          <option value="">All Severity</option>
          <option value="critical">Critical</option>
          <option value="error">Error</option>
          <option value="warning">Warning</option>
          <option value="info">Info</option>
        </select>

        <button
          onClick={() => {
            setSearch("");
            setSeverity("");
          }}
          className="px-4 py-2 text-gray-400 hover:text-white transition-colors duration-200"
        >
          Clear Filters
        </button>
      </div>

      {loading ? (
        <div className="flex justify-center py-12">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-cyan-400"></div>
        </div>
      ) : (
        <ErrorList errors={errors} />
      )}
    </div>
  );
}

export default Errors;
